import {Chip, Theme, useTheme} from "@mui/material";
import themeDefaults from "../../../Shared/Theme/ThemeDefaults";

export type PillTone =
    | "systemBlue"
    | "userOrange"
    | "dinBlue"
    | "dexGreen"
    | "openOrange"
    | "doneGreen"
    | "neutral"
    | "prGood"
    | "prWarning"
    | "prBad";

type PillPalette = { bg: string; fg: string };

export const pillColors: Record<PillTone, { light: PillPalette; dark: PillPalette }> = {
    systemBlue: {
        light: { bg: "#2F5BEA", fg: "#FFFFFF" }, // azul escuro (Sistema)
        dark:  { bg: "#4C74F0", fg: "#0B1330" },
    },
    userOrange: {
        light: { bg: "#F25C2A", fg: "#FFFFFF" }, // laranja (Usuário)
        dark:  { bg: "#EF5350", fg: "#2A0F04" },
    },
    dinBlue: {
        light: { bg: "#6B87FF", fg: "#FFFFFF" }, // azul claro (DIN)
        dark:  { bg: "#8DA2FF", fg: "#141C40" },
    },
    dexGreen: {
        light: { bg: "#18B77E", fg: "#FFFFFF" }, // verde (DEX)
        dark:  { bg: "#8CE49F", fg: "#062A1C" },
    },
    openOrange: {
        light: { bg: "#F25C2A", fg: "#FFFFFF" }, // laranja (Em aberto)
        dark:  { bg: "#EF5350", fg: "#2A0F04" },
    },
    doneGreen: {
        light: { bg: "#18B77E", fg: "#FFFFFF" }, // verde (Finalizado)
        dark:  { bg: "#8CE49F", fg: "#062A1C" },
    },
    neutral: {
        light: { bg: "#454647", fg: "#FFFFFF" }, // fallback
        dark:  { bg: "#454647", fg: "#FFFFFF" },
    },
    prGood: {
        light: { bg: "rgba(67, 160, 71, 0.18)",  fg: "#1BB483" }, // PR 70–95 (verde)
        dark:  { bg: "rgba(67, 160, 71, 0.18)",  fg: "#8CE49F" },
    },
    prWarning: {
        light: { bg: "rgba(251, 140, 0, 0.18)",  fg: "#F57F17" }, // PR 60–69 ou >95 (âmbar)
        dark:  { bg: "rgba(251, 140, 0, 0.18)",  fg: "#FF8F00" },
    },
    prBad: {
        light: { bg: "rgba(244, 67, 54, 0.15)",  fg: "#D32F2F" }, // PR <60 (vermelho)
        dark:  { bg: "rgba(244, 67, 54, 0.15)",  fg: "#EF5350" },
    },
};

export function Pill({ label, tone }: { label: string; tone: PillTone }) {
    const theme = useTheme();
    const color = pillColors[tone][theme.palette.mode === 'light' ? 'light' : 'dark'];

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                height: 24,
                borderRadius: 999,
                bgcolor: color.bg,
                color: color.fg,
                fontWeight: 600,
                fontSize: 12,
                "& .MuiChip-label": {
                    px: 1.25,
                    py: 0,
                },
            }}
        />
    );
}